import { ReactElement } from 'react';

type Props = {
  width?: number;
  widthp?: number;
  height?: number;
  className?: string;
};

/**
 * The width prop expresses width in pixels, while widthp does it in
 * percentual values. If you add both, widthp takes precedence.
 */
function SkeletonLine({
  width = 160,
  height = 16,
  widthp,
  className = '',
}: Props): ReactElement {
  return (
    <div
      className={[
        'c-skeleton-line',
        widthp
          ? `c-skeleton-line--w${widthp}p`
          : `c-skeleton-line--w${width}`,
        `c-skeleton-line--h${height}`,
        className,
      ].join(' ')}
    />
  );
}

export default SkeletonLine;
